import { useGetDeviceType } from "_common/hooks/global";
import Typography           from "_components/atoms/typography";
import { Fragment }         from "react";
import { InView }           from "react-intersection-observer";
import { Waypoint }         from "react-waypoint";
import EmptyFeed            from "../../notificationFeedEmptyView";
import FeedItem             from "../notificationFeedItem";
import useStyles            from "./styles";

const Component = props => {
	const { newArr,
		earlierArr,
		handleFeedItem,
		isDepleted,
		isFetching,
		fetchMoreData,
		handleNotificationClick,
		handleGoToSeeAllPage,
		marked,
		isNotificationsPage,
		activeTab,
		handleNotificationImpression,
		handleMarkAllRead } = props;
	const { classes } = useStyles ( undefined, { name: "styles" } );

	// sometimes fetching data might have feed list length less than threshold
	const earlierArrWaypointIndex = earlierArr?.length < 4 ? 1 : 4;
	const newArrWaypointIndex     = newArr?.length < 4 ? 1 : 4;

	const deviceType = useGetDeviceType ();

	const isMobile = deviceType === "mobile";

	return (
		<div className = { classes.feedWrapper }>
			{
				newArr?.length ? (
					<div className = { classes.forMeTabHeader }>
						<Typography
							className = { `bold ${ classes.title }` }
							title     = "New"
						/>

						{
							isMobile ? (
								<Typography
									className = { classes.markAllRead }
									color     = "secondary"
									onClick   = { handleMarkAllRead }
									title     = "Mark All Read"
								/>
							) : null
						}

						{
							!isNotificationsPage ? (
								<Typography
									className = { classes.markAllRead }
									color     = "secondary"
									onClick   = { handleGoToSeeAllPage }
									title     = "See All"
								/>
							) : null
						}
					</div>
				) : null
			}

			{
				newArr?.length ? (
					<div>
						{
							newArr?.map ( ( feedItem, index ) => {

								return (
									<Fragment key = { index }>
										<InView as = "div"
											onChange = { inView => {

												if ( inView ) {
													return handleNotificationImpression ( feedItem );

												} else {

													return null;
												}

											} }
											threshold = { 0.7 }
										>

											<FeedItem
												feedItem                = { feedItem }
												handleFeedItem          = { handleFeedItem }
												handleNotificationClick = { data => handleNotificationClick ( { data, type: "new" } ) }
												marked                  = { marked }
											/>
										</InView>

										{ earlierArr.length === 0 && !isDepleted && !isFetching && newArr.length > 0 && index === newArr.length - newArrWaypointIndex && (
											<Waypoint
												onEnter = { () => fetchMoreData () }
											/>
										)}
									</Fragment>
								);
							} )
						}
					</div>
				) : null
			}

			{
				earlierArr?.length ? (
					<div className = { classes.subHeader }>
						<Typography
							className = { `bold ${ classes.title }` }
							title     = "Earlier"
						/>

						{
							!isNotificationsPage && !newArr?.length ? (
								<Typography
									className = { classes.markAllRead }
									color     = "secondary"
									onClick   = { handleGoToSeeAllPage }
									title     = "See All"
								/>
							) : null
						}
					</div>
				) : null
			}

			{
				<div>
					{
						earlierArr?.map ( ( feedItem, index ) => {

							return (
								<Fragment key = { index }>
									<InView as = "div"
										onChange = { inView => {

											if ( inView ) {
												return handleNotificationImpression ( feedItem );

											} else {

												return null;
											}

										} }
										threshold = { 0.7 }
									>
										<FeedItem
											feedItem                = { feedItem }
											handleFeedItem          = { handleFeedItem }
											handleNotificationClick = { data => handleNotificationClick ( { data, type: "earlier" } ) }
											marked                  = { marked }
										/>
									</InView>

									{ !isDepleted && !isFetching && earlierArr.length > 0 && index === earlierArr.length - earlierArrWaypointIndex && (
										<Waypoint
											onEnter = { () => fetchMoreData ( ) }
										/>
									)}
								</Fragment>
							);
						} )
					}
				</div>
			}

			{
				newArr?.length === 0 && earlierArr?.length === 0 ? (
					<div className = { classes.feedWrapper }>
						<EmptyFeed activeTab = { activeTab } />
					</div>
				) : null
			}
		</div>
	);
};

export default Component;
